export default "__VITE_ASSET__IBQJr9T8__"